import React from "react";

const GetInTouch = ({ heading, message, email }) => {
  return (
    <>
      <h3>Useful Links</h3>
      <a href="https://github.com/ulab-uiuc">Github</a>{" "}
      <a href="https://x.com/youjiaxuan">X</a>
    </>
  );
};

export default GetInTouch;
